'use client';
import { event_button_click } from '@/utils/gtm';
import { Button } from '@/components/ui/buttons';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import { useRouter } from '@/i18n/navigation';
import { SHIPPING_INFO_MODALS_NAMES } from '@/constants';
import { useSession } from 'next-auth/react';
import useCheckout from '@/store/checkout.store';

const ShippingMethod = ({
  shippingMethod,
  setShippingMethod,
  setIsOpenShippingInfoModal,
  setModalStep,
  setShippingAddress,
}) => {
  const t = useTranslations('modals');
  const { push } = useRouter();

  const { data: session } = useSession();

  const handleSelectMethod = (method) => {
    setShippingMethod(method);
    setShippingAddress(null);
  };

  return (
    <>
      <div className='px-[29px] pt-3.5 max-sm:px-1.75'>
        <p className='text-sm max-sm:text-xs'>
          {t('Product availability may vary by location')}
        </p>
        <div className='flex gap-[19px] py-5 max-sm:gap-2'>
          <ShippingMethodCard
            title='Home Delivery'
            subTitle='As fast as possible within 2 hours'
            iconPath='/svgs/house-2.svg'
            method={SHIPPING_INFO_MODALS_NAMES.HOME_DELIVERY}
            handleSelectMethod={handleSelectMethod}
            selectedMethod={shippingMethod}
            setModalStep={setModalStep}
            session={session}
          />

          <ShippingMethodCard
            title='Store Pickup'
            subTitle='Select a pickup time'
            iconPath='/svgs/shop-add.svg'
            method={SHIPPING_INFO_MODALS_NAMES.STORE_PICKUP}
            handleSelectMethod={handleSelectMethod}
            selectedMethod={shippingMethod}
            setModalStep={setModalStep}
            session={session}
          />
        </div>
      </div>

      {!session?.user && (
        <div className='border-t border-t-[#DDDDDD] pb-5 max-sm:px-1.75'>
          <Button
            onClick={() => {
              event_button_click({
                button_name: 'Login To View Saved Addresses',
                button_destination: `/login?modal=${SHIPPING_INFO_MODALS_NAMES.DELIVERY_ADDRESS}`,
                button_location: 'shipping_modal',
              });
              push(
                `/login?modal=${SHIPPING_INFO_MODALS_NAMES.DELIVERY_ADDRESS}`
              );
              setIsOpenShippingInfoModal(false);
            }}
            className='bg-primary mx-auto mt-[15px] flex h-[45px] w-[36.688rem] items-center justify-center rounded-[5px] text-[15px] font-bold text-white max-sm:w-full max-sm:text-sm'
          >
            {t('Log in to view your saved addresses')}
          </Button>
        </div>
      )}
    </>
  );
};

export default ShippingMethod;

const ShippingMethodCard = ({
  title,
  // subTitle,
  iconPath,
  selectedMethod,
  method,
  handleSelectMethod,
  setModalStep,
  session,
}) => {
  const t = useTranslations('modals');
  const setActiveShippingMethod = useCheckout(
    (state) => state.setActiveShippingMethod
  );
  return (
    <div
      onClick={() => {
        handleSelectMethod(method);
        if (method === SHIPPING_INFO_MODALS_NAMES.STORE_PICKUP) {
          setModalStep(SHIPPING_INFO_MODALS_NAMES.CHOOSE_BRANCH);
        } else {
          if (session?.user) {
            setModalStep(SHIPPING_INFO_MODALS_NAMES.DELIVERY_ADDRESS);
          }
        }

        setActiveShippingMethod(null);
      }}
      className={`flex h-[11.563rem] w-71 cursor-pointer flex-col items-center justify-center rounded-[10px] border ${selectedMethod === method ? 'border-primary border-2' : 'border-[#D9D9D9]'}`}
    >
      <Image
        src={iconPath}
        alt={method}
        width={48}
        height={48}
        className='mb-3.5 size-12 max-sm:size-[30px]'
      />

      <h3 className='mb-[7px] text-[16px] font-bold max-sm:text-sm'>
        {t(title)}
      </h3>
      {/* {false && <p className='text-center text-sm max-sm:text-xs'>{t(subTitle)}</p>} */}
    </div>
  );
};
